const EMPTY = 'EMPTY';
const SUCCESS = 'SUCCESS';
const LOADING = 'LOADING';

export { EMPTY, SUCCESS, LOADING };
